import React from 'react';
import { MEMES_SUB_MENU, ModeValue, SubModeValue } from '@shared/types/frontend/searchHome';
import ImageWithFallback from '@/components/shared/ImageWithFallback';
import { ToggleGroup, ToggleGroupItem } from '@/components/ui/toggle-group';
interface FilterMemeModeProps {
  setMode: (_: ModeValue) => void;
  subMode: SubModeValue;
  setSubMode: React.Dispatch<React.SetStateAction<SubModeValue>>;
}
const TrendingMemeToggleGroup = ({
  mode,
  setSubMode
}) => {
  const handleToggle = (value: string) => {
    setSubMode(value);
  };
  return <ToggleGroup type='single' value={mode} onValueChange={handleToggle} className='flex justify-start overflow-x-scroll px-4' data-sentry-element="ToggleGroup" data-sentry-component="TrendingMemeToggleGroup" data-sentry-source-file="MobileMemeMode.tsx">
      {MEMES_SUB_MENU.map(item => <ToggleGroupItem key={item.label} value={item.modeValue} className={`${item.modeValue === mode && 'bg-genius-blue'} disabled:opacity-100 text-[16px] flex gap-2 items-center rounded-[8px] text-genius-cream w-fit h-[32px] py-[3px] px-3`} disabled={item.modeValue === mode}>
          {item.isImage ? <ImageWithFallback src={`/icons/${item.isImage}`} alt={item.label} width={16} height={16} /> : item.img}
          <p className=''>{item.label}</p>
        </ToggleGroupItem>)}
    </ToggleGroup>;
};
const MobileMemeMode = ({
  subMode,
  setSubMode
}: FilterMemeModeProps) => {
  return <div className='grid gap-2 justify-items-start overflow-x-scroll no-scrollbar' data-sentry-component="MobileMemeMode" data-sentry-source-file="MobileMemeMode.tsx">
      <TrendingMemeToggleGroup mode={subMode} setSubMode={setSubMode} data-sentry-element="TrendingMemeToggleGroup" data-sentry-source-file="MobileMemeMode.tsx" />
    </div>;
};
export default MobileMemeMode;